import styled, { keyframes } from 'styled-components';
import { Modal } from 'antd';

const slideIn = keyframes` 
  0% {
    left: -100%;
    width: 0px; }
100% { 
  left: 0;
  width: 350px; 
}
`;
export const Container = styled.div`
  background: #fff;
  height: calc(100% - 70px);
  top: 70px;
  position: relative;
  z-index: 99;
  animation: ${props => props.display ? slideIn : "none"} 0.5s ease-in;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
  width: ${props => props.CurrentDesign === 'document'?'586px':'350px'} !important;
`;

export const Title = styled.div`
  font-weight: bold;
  color: #0e1318;
  padding: 0 30px;
  font-size: 16px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 0 rgba(14, 19, 24, 0.15);
  input {
    font-size: 14px;
  }
`;

export const PropertiesContainer = styled.div`
  display: flex;
  height: calc(100% - 120px);
  overflow-y: auto;
  width: 100% !important;
  overflow-x: hidden; /* Hide horizontal scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  z-index: 99;
  border-bottom: 1px solid lightgrey;
  ul{
    width: 100% !important;
  }
  li {
    padding: 0 20px;
    min-height: 40px;
    align-items: center;
    display: flex;
    cursor: pointer;
    &:hover {
      background-color:#eeeeee !important;
    }
    span {
      &:first-child {
        width: 90%;
      }
      &:last-child {
        display: flex;
        align-items: center;
      }
    }
  }
  li.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    &:hover {
      background-color: transparent !important;
    }
  }
`;

export const UplaodView = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  height: 60px;
  bottom: 0px;
`;
export const UploadButton = styled.div`
  display: flex;
  width: 50%;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: ${props => props.background};
  color:#fff;
  background: rgb(37,41 ,45);
  i {
    padding: 0 10px;
  }
`;

export const ApplyFontConfirmation = styled(Modal)`
  p {
    font-family: 'Open Sans', sans-serif;
    color: #000;
  }
  a {
    text-underline-position: under;
  }
  .footer {
    display: flex;
    column-gap: 24px;
    width: fit-content;
    margin: auto;
    flex-wrap: wrap;
  }
  .ant-modal-footer {
    padding-bottom: 34px !important;
    .ant-btn:first-child {
      background: #f3f3f3 !important;
      color: #333 !important;
    }
    .ant-btn:last-child {
      color: #fff !important;
      background: #000 !important;
    }
  }
`;
